angular.module('dashboard')
    .component('dashboardCalendar', {
        templateUrl: 'app/dashboard/dashboard-calendar.html',
        controller: function ($scope, $rootScope, DocumentType, TaskStatus, DocumentFilterService, TaskCalendarV4Service, Principal) {
            this.documentFilterService = DocumentFilterService;

            this.$onInit = () => {
                this.filters = DocumentFilterService.filters
                DocumentType.query({doc: "task"}).$promise.then(items => this.documentTypes = items)
                TaskStatus.list().$promise.then(items => this.statuses = items)

                let calendarConfig = TaskCalendarV4Service.defaultConfig();
                calendarConfig.defaultView = 'dayGridMonth';
                calendarConfig.eventSources = [
                    {
                        url: '/crm/api/task/find',
                        extraParams: this.getExtraParams
                    }
                ];
                if (Principal.hasAnyAuthority(['ROLE_NOTES'])) {
                    calendarConfig.eventSources.push({
                        url: '/crm/api/note/find',
                        extraParams: this.getExtraParams
                    });
                }
                calendarConfig.eventSources.push({
                    url: '/crm/api/leave/calendar',
                    extraParams: this.getExtraParams
                });
                this.taskCalendarConfig = calendarConfig
            }

            this.refreshDashboard = () => {
                $rootScope.$broadcast('task.updated')
                $rootScope.$broadcast('note.updated')
            }

            this.onCalendarInit = calendar => this.calendar = calendar

            this.getExtraParams = () => {
                return Object.entries(this.filters)
                    .filter(([_, v]) => v != null)
                    .reduce((acc, [k, v]) => ({...acc, [k]: v}), {});
            }

            this.toggleWorkerFilter = name => {
                this.documentFilterService.toggle(name);
                this.search();
            }

            this.search = () => {
                this.documentFilterService.save();
                this.calendar.refetchEvents();
            }

            $scope.$on('$destroy', () => this.calendar.destroy());

            $scope.$on('task.updated', () => this.calendar.refetchEvents())
            $scope.$on('task.deleted', () => this.calendar.refetchEvents())
            $scope.$on('authenticationChanged', () => this.calendar.refetchEvents())
        }
    })
